// Service status configuration for MVP
// Determines which services are active (MVP) vs in development

export const SERVICE_STATUS = {
  // Active MVP services - normal styling, fully functional
  ACTIVE: ['/info', '/connections', '/education', '/aid', '/about'],
  
  // In development services - light gray styling, still accessible
  IN_DEVELOPMENT: [
    '/shopping',
    '/ride',
    '/creators',
    '/match',
    '/media',
    '/delivery',
    '/streaming',
    '/contact'
  ]
};

// Check if a path is active (MVP)
export const isActiveService = (path) => {
  return SERVICE_STATUS.ACTIVE.includes(path);
};

// Check if a path is in development
export const isInDevelopment = (path) => {
  return SERVICE_STATUS.IN_DEVELOPMENT.includes(path);
};

// Get service status
export const getServiceStatus = (path) => {
  if (isActiveService(path)) {
    return 'active';
  } else if (isInDevelopment(path)) {
    return 'in_development';
  }
  return 'unknown';
};

// Get styling classes for service based on status
export const getServiceStyles = (path) => {
  const status = getServiceStatus(path);
  
  if (status === 'in_development') {
    return {
      container: 'opacity-50 grayscale',
      text: 'text-gray-400',
      hover: 'hover:opacity-60',
      cursor: 'cursor-not-allowed'
    };
  }
  
  return {
    container: '',
    text: '',
    hover: '',
    cursor: ''
  };
};
